/* eslint-disable react/no-danger */
import React, { memo } from "react";
// import { ClipboardButton } from "@components";
import type { IMacro } from "features/editor/types";

const getTargetMarcoIndex = (e: React.MouseEvent) => {
  const index =
    (e.target as HTMLElement)?.dataset?.macroIndex ??
    ((e.target as HTMLElement)?.parentNode as HTMLElement)?.dataset?.macroIndex;

  return index ? parseInt(index, 10) : null;
};

export const OriginalText = memo(
  ({
    originalHtml,
    macros,
    handleOriginalMacroClick,
  }: {
    originalHtml: string;
    macros: Map<string, IMacro>;
    handleOriginalMacroClick: any;
  }) => {
    const onOriginalTextClick = (e: React.MouseEvent) => {
      const index = getTargetMarcoIndex(e);
      let macro;

      // eslint-disable-next-line no-restricted-syntax
      for (const value of macros.values()) {
        if (value.index === index) {
          macro = value;
        }
      }

      if (macro) {
        handleOriginalMacroClick(macro);
      }
    };

    return (
      <>
        <div
          role="none"
          onClick={onOriginalTextClick}
          dangerouslySetInnerHTML={{
            __html: originalHtml,
          }}
        />
        {/* <ClipboardButton onGetText={() => originalHtml} /> */}
      </>
    );
  },
);
